<template>
  <p-vue-panel v-if="supplier" class="supplier-panel">
    <template #header>
      <div
        class="p-d-flex p-jc-between"
        style="width:100%"
        @click="showSupplierData"
      >
        <div class="p-panel-title">
          <div>
            {{ supplier.Company }}
          </div>
        </div>
        <div
          :class="{
            rotate: supplier.showData,
          }"
        >
          <i-icon name="arrow" />
        </div>
      </div>
    </template>
    <div>
      <div class="grid">
        <div class="p-d-flex p-flex-column">
          <span>{{ __("Main domain") }}:</span>
          <span class="supplier-data">{{ supplier.GroupName }}</span>
        </div>
        <div class="p-d-flex p-flex-column">
          <span>{{ __("Secondary domain") }}:</span>
          <span class="supplier-data">{{ supplier.ssType }}</span>
        </div>
      </div>
      <div class="p-d-flex p-flex-column p-my-2">
        <span>{{ __("Comments") }}:</span>
        <span v-if="supplier.showData" class="supplier-data">
          {{ supplier.Notes }}
        </span>
        <span v-else class="supplier-data">
          {{ supplier.Notes.substring(0, 90) }}
          {{ supplier.Notes.length > 90 ? "..." : "" }}
        </span>
      </div>
    </div>
    <p-transition-expand>
      <div v-if="supplier.showData">
        <div class="grid">
          <div class="p-d-flex p-flex-column">
            <span>{{ __("Address") }}:</span>
            <span class="supplier-data">{{ supplier.address }}</span>
          </div>
          <div class="p-d-flex p-flex-column">
            <span>{{ __("Website") }}:</span>
            <span class="supplier-data">{{ supplier.Website }}</span>
          </div>
        </div>
        <div class="p-d-flex p-jc-end p-mt-2" style="gap: 10px;">
          <p-vue-button
            icon="pi pi-pencil"
            class="p-button-rounded p-button-success p-button-outlined"
            @click="showUpdateModal = true"
          />
          <p-vue-button
            icon="pi pi-trash"
            class="p-button-rounded p-button-danger p-button-outlined"
            @click="confirmDelete"
          />
        </div>
        <div class="contacts">
          <div class="p-my-2 contact-title">{{ __("Contacts") }}:</div>
          <local-contacts :contacts="supplier.Contacts"></local-contacts>
        </div>
      </div>
    </p-transition-expand>
    <div v-if="!supplier.showData" class="p-d-flex p-jc-end" style="gap: 10px;">
      <p-vue-button
        icon="pi pi-pencil"
        class="p-button-rounded p-button-success p-button-outlined"
        @click="showUpdateModal = true"
      />
      <p-vue-button
        icon="pi pi-trash"
        class="p-button-rounded p-button-danger p-button-outlined"
        @click="confirmDelete"
      />
    </div>
  </p-vue-panel>
  <i-override-dialog
    v-model:visible="showUpdateModal"
    :style="{
      width: '100%',
      maxWidth: 'calc(100vw - 10px)',
    }"
    :modal="true"
    :dismissableMask="true"
    :title="__('update') + ' ' + __('Supplier')"
  >
    <local-add-supplier
      :close="
        () => {
          showUpdateModal = false;
        }
      "
      :supplier="supplier"
      @supplierUpdate="supplierUpdate"
    ></local-add-supplier>
  </i-override-dialog>
</template>

<script>
import PTransitionExpand from "@/components/partials/p-transition-expand";
import LocalAddSupplier from "./add-supplier";
import { __ } from "@/plugins/i18n/";
import { errorReceived, showSuccessOrFailedModal } from "@/services/apointUtil";
import { callProc, apiParam, apiPType } from "@/services/APointAPI";
import LocalContacts from "./contacts/index";

export default {
  components: {
    PTransitionExpand,
    LocalAddSupplier,
    LocalContacts,
  },
  props: {
    supplier: {
      type: Object,
    },
  },
  emits: ["showSupplierData", "DeleteSupplier"],
  data() {
    return {
      showUpdateModal: false,
      supplierLocal: {},
    };
  },
  mounted() {
    // console.log(this.supplier);
    this.supplierLocal = this.supplier;
  },
  methods: {
    showSupplierData() {
      this.$emit("showSupplierData", this.supplier);
    },
    saveUpdate() {
      // console.log("saveUpdate", this.supplier);
    },
    confirmDelete(event) {
      this.$confirm.require({
        target: event.currentTarget,
        message: __("Are you sure?"),
        icon: "pi pi-exclamation-triangle",
        accept: () => {
          this.deleteInDB();
        },
        reject: () => {},
      });
    },
    deleteInDB() {
      this.$store.dispatch("doLoading", true);
      let procParams = [
        apiParam("UserNum", this.userNum, apiPType.Int),
        apiParam("SupplierID", this.supplier.SupplierID, apiPType.Int),
      ];
      callProc("WorkerApp_DeleteSupplier", procParams)
        .then((result) => {
          result = JSON.parse(result);
          if (result.procReturnValue == 0) {
            showSuccessOrFailedModal(__("Power deleted successfully"));
            setTimeout(() => {
              this.$emit("DeleteSupplier", this.supplier.SupplierID);
            }, 1000);
          } else {
            showSuccessOrFailedModal(__(result.Table[0].desc), false);
          }
          this.$store.dispatch("doLoading", false);
        })
        .catch(() => {
          errorReceived("WorkerApp_DeleteSupplier");
        });
    },
    supplierUpdate(s) {
      this.supplierLocal = s;
      this.showUpdateModal = false;
    },
  },
};
</script>

<style scoped>
.rotate {
  transform: rotate(180deg);
}

:deep(.svg) {
  color: var(--color-success);
  width: 24px;
  height: 24px;
}

.supplier-data {
  color: var(--color-accent);
}

.grid {
  display: grid;
  grid-template-columns: 50% 50%;
}

.supplier-panel:deep(.p-panel-header .p-panel-title) {
  margin: 0 auto;
  font-size: 22px;
}

.contact-title {
  font-size: 18px;
  text-decoration: none;
  letter-spacing: 0.51px;
  font-weight: 600;
  color: var(--color-accent);
}
</style>
